import { RiCarouselView } from "react-icons/ri";
import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Card Slider",
  name: "cardSlider",
  type: "object",
  icon: RiCarouselView,
  fields: [
    {
      name: "sectionLayoutConfig",
      type: "sectionLayoutConfig",
      title: "Section Layout",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "heading",
      title: "Heading",
      type: "sectionTitle"
    },
    {
      name: "items",
      title: "Cards",
      type: "array",
      of: [{ type: "sliderCard" }, { type: "packageCard" }]
    }
  ],
  preview: {
    select: {
      title: "heading.title",
      items: "items"
    },
    prepare({ title, items }) {
      return {
        title: multilingualStringPreview(title) || "([Card] Slider)",
        subtitle: `${items.length} slides`
      };
    }
  }
});
